// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/.pnpm/css-loader@4.3.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-content-empty[data-v-4d7358fc]{-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;justify-content:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
